import { render, staticRenderFns } from "./bookingCardPeople.vue?vue&type=template&id=cb1c259e&scoped=true&"
import script from "./bookingCardPeople.vue?vue&type=script&lang=js&"
export * from "./bookingCardPeople.vue?vue&type=script&lang=js&"
import style0 from "./bookingCardPeople.vue?vue&type=style&index=0&id=cb1c259e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1c259e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
